import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from 'react';

import { DetachTaskModal } from './detach-task.modal';

export type DetachTaskModalOpen = { id: string } | undefined;

const DetachTaskModalContext = createContext<
  (open: DetachTaskModalOpen) => void
>(() => {
  // This is a no-op function used as the default value for the context
  // It will be overridden by the actual provider
});

export function useDetachTaskModal() {
  return useContext(DetachTaskModalContext);
}

export function DetachTaskModalProvider({
  children,
}: PropsWithChildren<object>) {
  const [open, setOpen] = useState<DetachTaskModalOpen>(undefined);

  return (
    <DetachTaskModalContext.Provider value={setOpen}>
      {children}
      <DetachTaskModal open={open} onClose={() => setOpen(undefined)} />
    </DetachTaskModalContext.Provider>
  );
}
